export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8523.916a381b.jpg";